import { useState } from 'react'
import PropTypes from 'prop-types'

const DEFAULT = {
  func: () => {},
  obj: {}
}

export function useStep (initialStep) {
  const [step, setStep] = useState(initialStep)

  const nextStep = (callback, data = DEFAULT.obj) => {
    setStep(step + 1)

    if (typeof callback === 'function') {
      callback(data)
    }
  }

  const prevStep = (callback, data = DEFAULT.obj) => {
    setStep(step - 1)
    if (typeof callback === 'function') {
      callback(data)
    }
  }

  return [prevStep, nextStep, step, setStep]
}

useStep.propTypes = {
  initialStep: PropTypes.string.isRequired
}
